import PropTypes from 'prop-types'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { useState } from 'react'
import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { mainGreen } from '../utils/color'

function SearchDialogTitle(props) {
	const { children, onClose, ...other } = props

	return (
		<DialogTitle sx={{ m: 0, paddingTop: '10px', paddingBottom: '10px' }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label='close'
					onClick={onClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 6,
						color: (theme) => theme.palette.grey[500],
					}}>
					<CloseIcon />
				</IconButton>
			) : null}
		</DialogTitle>
	)
}

SearchDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
}

export default function SearchInput() {
	const navigate = useNavigate()
	const [searchInput, setSearchInput] = useState('')

	const handleChange = (e) => {
		setSearchInput(e.target.value)
	}

	const postSearch = async function () {
		if (searchInput.trim() !== '') {
			navigate(`/user/search/${searchInput}`)
		}
	}

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			postSearch()
		}
	}

	return (
		<div>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
				}}
				id='search-input-wrapper'>
				<input
					value={searchInput}
					style={{ width: '100%' }}
					id='search-input'
					type='text'
					placeholder='Tìm kiếm'
					onChange={handleChange}
					onKeyDown={handleKeyDown}
				/>
				<SearchOutlinedIcon
					sx={{ cursor: 'pointer', color: mainGreen }}
					onClick={() => {
						postSearch()
					}}
				/>
			</Box>
		</div>
	)
}
